package pt.at.oss.kotlin.manual.storage.intermediaryForm

import kotlinx.serialization.Serializable
import pt.at.oss.kotlin.manual.storage.common.Address
import pt.at.oss.kotlin.manual.storage.common.VatId
import pt.at.oss.kotlin.manual.storage.common.bankaccountinfo.BankAccountInfo
import pt.at.oss.kotlin.manual.storage.common.contactinfo.ContactInfo
import pt.at.oss.kotlin.manual.storage.common.contactname.ContactName
import pt.at.oss.kotlin.manual.storage.common.currvatid.CurrVatId
import pt.at.oss.kotlin.manual.storage.common.fixedestablishments.FixedEstablishmentsEntry
import pt.at.oss.kotlin.manual.storage.common.relevantdates.RelevantDates
import pt.at.oss.kotlin.manual.storage.common.tradingnames.TradingNamesEntry
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * IntermediaryForm Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class IntermediaryForm(
    var currVatId: CurrVatId? = CurrVatId(),
    var bankAccountInfo: BankAccountInfo = BankAccountInfo(),
    var fixedEstablishments: MutableList<FixedEstablishmentsEntry> = mutableListOf(),
    var identificationOfBusiness: VatId = VatId(),
    var companyName: String = "",
    var tradingNames: MutableList<TradingNamesEntry> = mutableListOf(),
    var countryOfBusiness: String? = null,
    var cobRegion: String? = null,
    var address: Address = Address(),
    var contactName: ContactName = ContactName(),
    var contactInfo: ContactInfo = ContactInfo(),
    var prevOrCurrOssVatId: MutableList<VatId> = mutableListOf(),
    var relevantDates: RelevantDates? = RelevantDates()
) : BaseRecord()
